import React, { useState, useEffect } from 'react';
import { Table, Button } from 'antd';
import PropTypes from 'prop-types';
import { parseColumnsForRunInstanceSummaryListing } from './utils';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../constants/globalConstants';
import ViewExecutionActivityLog from './viewExecutionActivityLog';
import Wait4Me from '../../../../components/Wait4Me';
import get from 'lodash/get';

import styles from './index.scss';
import { MODULE_SOURCEID_MAPPING } from '../../../../util/GlobalConstant';
import { isResourceAvailable } from '../../../../util';

const resourceCode = 'amls:ui:common-ticket:read';

export const RunInstanceSummary = ({
  runInstanceSummaryData,
  apiActions,
  settings,
  authentication,
  runInstanceViewExecution
}) => {
  const { getNSRunInstanceSummaryData } = apiActions;
  const { isLoading, data } = runInstanceSummaryData;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [readyToProduction, setReadyToProduction] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const sourceId =
    MODULE_SOURCEID_MAPPING[
      get(authentication, 'currentProductLogin.moduleCode')
    ] || '';

  useEffect(() => {
    getNSRunInstanceSummaryData({
      offset: (currentPage - 1) * pageSize,
      limit: pageSize,
      sourceId
    });
  }, [pageSize, currentPage, sourceId]);

  const onPaginationChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
  };

  const hanldeDrawerHanlder = (record) => {
    setDrawerVisible(!drawerVisible);
    if (record) {
      setSelectedData(record);
    }
  };

  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  const GS = getGSConfig({
    widgetGroupId: 'NS_IAD_RUN_INSTANCES_LIST',
    widgetId: 'NS_IAD_RUN_INSTANCES_LIST'
  });

  const columns = parseColumnsForRunInstanceSummaryListing(
    GS && GS.widgetConfig,
    apiActions,
    hanldeDrawerHanlder
  );

  const rowSelection = {
    type: 'radio',
    onChange: (selectedRowKeys, selectedRows) => {
      setReadyToProduction(selectedRows[0]);
    },
    getCheckboxProps: (record) => ({
      disabled: record?.executionStatus?.toLowerCase() !== 'completed',
      name: record.executionStatus
    })
  };

  const deployToProductionHandler = () => {
    if (apiActions && readyToProduction !== null) {
      apiActions.navigateTo(
        `${ROUTE_AMLS_SMART_SCREENING}/runInstance/${readyToProduction.id}/deployInProduction`,
        readyToProduction
      );
    }
  };

  return (
    <div className={styles.runInstanceSummary_wrapper}>
      <React.Fragment>
        <h3>Run Instance Summary</h3>
        <div className={styles.filterHead}>
          <div></div>
          {isResourceAvailable(authentication, resourceCode) && (
            <Button
              type="primary"
              id="deployInProductionbtn"
              disabled={readyToProduction == null}
              onClick={deployToProductionHandler}>
              Deploy in Production
            </Button>
          )}
        </div>
        {settings?.nsSetting?.isLoading ? (
          <div className={styles.loadingWrapper}>
            <Wait4Me />
          </div>
        ) : (
          GS?.isVisible && (
            <Table
              id="runInstanceSummaryListing"
              rowSelection={
                isResourceAvailable(authentication, resourceCode) && {
                  ...rowSelection
                }
              }
              className={styles.table}
              dataSource={data?.payload}
              columns={columns}
              loading={isLoading}
              rowKey="id"
              pagination={{
                showSizeChanger: true,
                responsive: false,
                total: data?.total,
                current: currentPage,
                pageSize,
                onChange: onPaginationChange,
                pageSizeOptions: [5, 10, 25, 50, 100],
                showTotal: (total) => `${total} Records`
              }}
              scroll={{ y: 240 }}
            />
          )
        )}
        {drawerVisible && (
          <ViewExecutionActivityLog
            onClose={hanldeDrawerHanlder}
            visible={drawerVisible}
            selectedData={selectedData}
            runInstanceViewExecution={runInstanceViewExecution}
            apiActions={apiActions}
            GS={getGSConfig({
              widgetGroupId: 'NS_IAD_RUN_INSTANCE_ACTIVITY_LOG',
              widgetId: 'NS_IAD_RUN_INSTANCE_ACTIVITY_LOG'
            })}
          />
        )}
      </React.Fragment>
    </div>
  );
};

RunInstanceSummary.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  runInstanceSummaryData: PropTypes.object.isRequired,
  runRunInstance: PropTypes.object,
  authentication: PropTypes.object,
  runInstanceViewExecution: PropTypes.object
};

export default RunInstanceSummary;
